export const FooterHandlers = () => {
    const toggles = document.querySelectorAll(
        ".footer__nav .navList li.hasChildren > .icon"
    );

    toggles.forEach((toggle) => {
        toggle.addEventListener("click", (event) => {
            toggleNavOpenState(event);
        });
    });

    removeUnnecessaryElements()
}

const toggleNavOpenState = (event) => {
    event.stopPropagation;
    const target = event.target as HTMLElement;

    if (!target) return;
    target.parentElement?.classList.toggle("open");
};

const removeUnnecessaryElements = () => {
    const navItems = document.querySelectorAll<HTMLUListElement>('.site-footer .navList li')
    navItems.forEach((item) => {
        item.removeAttribute('aria-expanded')
        item.removeAttribute('aria-haspopup')
        const iconToggles = item.querySelectorAll<HTMLButtonElement>('.icon')
        const backButtons = item.querySelectorAll<HTMLButtonElement>('.nav-back-btn')
        iconToggles.forEach((icon) => icon.remove())
        backButtons.forEach((btn) => btn.remove())
    })
}